import React, { useEffect, useState } from 'react';
import { usersManagementServices } from '../../../APIServices/usersManagementServices';
import { useToast } from '../../../hooks/useToast';

function DeleteUser({ getUserData, getDeletedUserData, setModalOpen, userData, title}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [user, setUser] = useState("");

  const softDeleteRestoreUser = async () => {
    setButtonLoader(true);
    try {
      let userDatas = {};
      userDatas.userId = userData?.userId;
      userDatas.type = "delete";
      let data = await usersManagementServices.softDeleteRestoreUser(
        userDatas
      );
      if (data?.statusCode === 200) {
        toast(data?.customMessage || `${title} deleted successfully.`, 'ok');
        getUserData();
        getDeletedUserData();
        setModalOpen("");
      } else {
        toast(data?.customMessage || `Unable to delete ${title?.toLowerCase() || 'user'}.`, 'warn');
      }
    } catch (error) {
      toast(`Unable to delete ${title?.toLowerCase() || 'user'}. Please try again.`, 'warn');
    } finally {
      setButtonLoader(false);
    }
  }

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Delete {title}
            </div>

            <div className="xs muted">
              Delete {title} Details
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-foot">
          <button
            className="btn btn-ghost"
            onClick={() => setModalOpen("")}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
            onClick={() => softDeleteRestoreUser()}
            disabled={buttonLoader}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Yes, Delete It!</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteUser;
